// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-spinner {
  position: relative;
  padding-right: 20px; /* space for spinner */
}

.cell-spinner::after {
  content: "";
  width: 12px;
  height: 12px;
  border: 2px solid #007bff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: translateY(-50%) rotate(0deg); }
  100% { transform: translateY(-50%) rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/components/employeeInformation/EmployeeInformation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,KAAK,wCAAwC,EAAE;EAC/C,OAAO,0CAA0C,EAAE;AACrD","sourcesContent":[".cell-spinner {\n  position: relative;\n  padding-right: 20px; /* space for spinner */\n}\n\n.cell-spinner::after {\n  content: \"\";\n  width: 12px;\n  height: 12px;\n  border: 2px solid #007bff;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  position: absolute;\n  right: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: translateY(-50%) rotate(0deg); }\n  100% { transform: translateY(-50%) rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
